<template>
  <v-dialog
    v-model="needHelpDialog"
    width="500"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    no-click-animation
    persistent
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <v-btn
          icon
          @click="closeDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <make-call @makeCall="makeCall" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>

import MakeCall from "@/views/Packs/partial/MakeCall.vue";
import UPDATE_USER_MUTATION from "@/graphql/mutations/UpdateUser.gql";

import { mapMutations, mapGetters } from "vuex";

export default {
  name: 'NeedHelp',
  components: {
    MakeCall,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("invoice", ["getPending"]),
    needHelpDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("closeNeedHelpDialog", val);
      }
    },
  },
  methods: {
    makeCall(val) {
      if (val) {
        this.step = 'show-shedule'
        return
      }
      this.closeDialog()
    },
    closeDialog() {
      this.needHelpDialog = false
    }
  }
}
</script>

<style lang="scss">

</style>
